import styled from 'styled-components'
import { BLACK, MEDIUM_GRAY, CRIMSON_500, GREEN_600, AMBER_500, VIOLET_400, BLUE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'
import type { PaymentLinkStatus } from '../PaymentLinkTransactionStatusIcon/PaymentLinkTransactionStatusIcon'

const STATUS_COLOR: Record<PaymentLinkStatus, string> = {
    OPEN: VIOLET_400,
    EXPIRED: MEDIUM_GRAY,
    VOID: CRIMSON_500,
    ACTION_REQUIRED: BLUE,
    RETURNED: AMBER_500,
    COMPLETED: GREEN_600,
    WAITING_FOR_PAYMENT: AMBER_500,
    PROCESSING: AMBER_500,
    INVALID_DEPOSIT: CRIMSON_500,
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  cursor: pointer;
` as any

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
` as any

export const LeftColumn = styled.div`
  display: flex;
  width: 50%;
  justify-content: flex-start;
  font-family: ${INTER.bold};
  font-size: 12px;
  color: ${BLACK};
` as any

export const RightColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 50%;
  justify-content: flex-end;
  font-family: ${INTER.extraBold};
  font-size: 13px;
  color: ${BLACK};
  gap: 4px;
` as any

export const CurrencyText = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
` as any

export const DateColumn = styled.div`
  display: flex;
  width: 40%;
  justify-content: flex-start;
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${BLACK};
` as any

export const StatusColumn = styled.div<{ $status: PaymentLinkStatus }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 60%;
  gap: 4px;
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${props => STATUS_COLOR[props.$status]};
` as any
